const api_url = "https://clairity-api-wo3uree3ha-uc.a.run.app/clairity";

export default api_url;